import { activeRequests } from '../data-fetch/urql-provider';
import { useKibanaLogger } from './kibana-logger/kibana-logger';
import { usePersistentCondition } from './usePersistentCondition';

interface UseLogQueryIsNotReadyProps {
  isQueryReady: boolean;
  queryIsDisabled?: boolean;
  queryName: string;
  additionalMetadata?: Record<string, unknown>;
}

export const useLogQueryIsNotReady = ({
  isQueryReady,
  queryIsDisabled = false,
  queryName,
  additionalMetadata,
}: UseLogQueryIsNotReadyProps) => {
  const { kibanaLogger } = useKibanaLogger();
  const durationMs = 6000;

  usePersistentCondition({
    condition: !isQueryReady && !queryIsDisabled,
    durationMs,
    callback: () => {
      const logPayload = {
        context: queryName,
        url: window.location.href,
        gql_query: {
          query: queryName,
          additional_metadata: additionalMetadata,
          active_requests: Array.from(activeRequests),
        },
      };

      if (activeRequests.size === 0) {
        kibanaLogger?.error(
          `Query ${queryName} is still paused after ${durationMs / 1000} seconds (no other GQL operations were active).`,
          logPayload
        );
      } else {
        kibanaLogger?.log(
          `Query ${queryName} is still paused after ${durationMs / 1000} seconds (${activeRequests.size} GQL queries in progress).`,
          logPayload
        );
      }
    },
  });
};
